import { createQueryKeys } from '@lukemorales/query-key-factory';
import { getRemittances } from '../admin/remittance.service';
import { getData } from '../utils/functional/fp';

export const remittances = createQueryKeys('remittances', {
  list: (filters: Record<string, unknown>) => ({
    queryKey: [{ filters }],
    queryFn: () => getRemittances({ params: filters }).then(getData),
  }),
});

